import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout/MainLayout';

// Page imports
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Leadership from './pages/Leadership/Leadership';
import Membership from './pages/Membership/Membership';
import Activities from './pages/Activities/Activities';
import Publications from './pages/Publications/Publications';
import Donate from './pages/Donate/Donate';
import Contact from './pages/Contact/Contact';
import Constitution from './pages/Constitution/Constitution';
import Login from './pages/Login/Login'; // Placeholder for future member dashboard

// Optional: 404 page (you can create this component later)
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* All routes wrapped in MainLayout (Header & Footer) */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="leadership" element={<Leadership />} />
          <Route path="membership" element={<Membership />} />
          <Route path="activities" element={<Activities />} />
          <Route path="publications" element={<Publications />} />
          <Route path="donate" element={<Donate />} />
          <Route path="contact" element={<Contact />} />
          <Route path="constitution" element={<Constitution />} />
          <Route path="login" element={<Login />} />
          {/* Catch-all for 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;